<template>
  <div class="p-2">
    <div
      class="flex gap-4 justify-center overflow-scroll p-3 no-scrollbar snap-x"
      ref="test"
    >
      <YearViewer
        v-for="year in [1402, 1403]"
        :key="year"
        :year="year"
        :active="year === selectedYear"
        @yearClicked="
          selectedYear = $event;
          selectedMonth = '';
          selectedDay = '';
        "
      />
    </div>
    <div class="flex gap-4 overflow-scroll p-3 no-scrollbar snap-x" ref="test">
      <MonthViewer
        v-for="month in 12"
        :key="month"
        :month="month"
        :active="month === selectedMonth"
        @monthClicked="
          selectedMonth = $event;
          selectedDay = '';
        "
      />
    </div>

    <div class="flex gap-4 overflow-scroll no-scrollbar snap-x py-2">
      <DayViewer
        v-for="day in daysInMonth"
        :key="day"
        :day="day"
        :month="selectedMonth"
        :active="day === selectedDay"
        @dayClicked="selectedDay = $event"
      />
    </div>
    <div class="grid grid-cols-1 gap-2 mt-4">
      <SaleProductChart
        :day="selectedDay"
        :month="selectedMonth"
        :year="selectedYear"
      />
    </div>
    <div class="grid grid-cols-1 gap-2 mt-4">
      <SaleCountChart
        :day="selectedDay"
        :month="selectedMonth"
        :year="selectedYear"
      />
    </div>
    <div class="grid grid-cols-1 gap-2 mt-4">
      <SaleTonajChart
        :day="selectedDay"
        :month="selectedMonth"
        :year="selectedYear"
      />
    </div>
    <div class="grid grid-cols-1 gap-2 mt-4">
      <SaleMabChart
        :day="selectedDay"
        :month="selectedMonth"
        :year="selectedYear"
      />
    </div>
  </div>
</template>
<script>
import MonthViewer from "../components/MonthViewer.vue";
import DayViewer from "../components/DayViewer.vue";
import YearViewer from "../components/YearViewer.vue";
import jDate from "jalali-date";
import SaleProductChart from "../components/SaleProductChart.vue";
import SaleCountChart from "../components/SaleCountChart.vue";
import SaleTonajChart from "../components/SaleTonajChart.vue";
import SaleMabChart from "../components/SaleMabChart.vue";
export default {
  name: "HorekaReport",
  components: {
    MonthViewer,
    DayViewer,
    YearViewer,
    SaleProductChart,
    SaleCountChart,
    SaleTonajChart,
    SaleMabChart,
  },
  data() {
    return {
      selectedDay: new jDate().getDate(),
      selectedMonth: new jDate().getMonth(),
      selectedYear: 1403,
      daysInMonth: "",
      loading: true,
    };
  },
  created() {
    this.getDaysInMonth();
  },
  methods: {
    getDaysInMonth() {
      let today = new jDate();
      if (this.selectedMonth <= 6) {
        this.daysInMonth = 31;
        return;
      }

      if (this.selectedMonth <= 11) {
        this.daysInMonth = 30;
        return;
      }

      if (jDate.isLeapYear(today.getFullYear())) {
        this.daysInMonth = 30;
        return;
      }

      this.daysInMonth = 29;
      return;
    },
  },
  watch: {
    // selectedDay() {
    //   if (this.selectedDay !== "") {
    //   }
    // },
    selectedMonth() {
      this.getDaysInMonth();
    },
  },
};
</script>
